/** sessionStorage keys for list filter query strings (prefix applied in hook). */
export const LIST_FILTER_SESSION_KEYS = {
  tickets: 'tickets',
  incidents: 'incidents',
  problems: 'problems',
  changes: 'changes',
  serviceRequests: 'serviceRequests',
  cases: 'cases',
  alerts: 'alerts',
  timeEntries: 'timeEntries',
  users: 'users',
  contacts: 'contacts',
  groups: 'groups',
} as const;
